module.exports = __webpack_public_path__ + "media/images/athletes/1665-5fcdb2c9d3da92c088c4f94ed582204e.png";